import EditableCard from 'components/EditableCard/EditableCard';
import ColumnWrapper from 'components/Layout/ColumnWrapper';
import { ProjectAiModuleModelType } from 'models/ProjectAiModuleModel';
import React from 'react';
import { useIntl } from 'react-intl';
import { useStores } from 'index';
import { FormType } from 'utils/hooks/useForm';

interface ProjectAiModuleContentProps {
  projectAiModule: ProjectAiModuleModelType;
  form: FormType;
  onSave: (projectAiModuleId: number, output: string) => void;
}

const ProjectAiModuleContent: React.FC<ProjectAiModuleContentProps> = ({
  projectAiModule,
  form,
  onSave
}) => {
  const { applicationStore } = useStores();
  const intl = useIntl();

  return (
    <ColumnWrapper>
      <h2 className="fire-detail-screen__title">
        {projectAiModule.ai_module?.intro_text}
      </h2>

      {projectAiModule.output && (
        <EditableCard
          form={form}
          name={`ai_module_output_${projectAiModule.id}`}
          label={projectAiModule.ai_module?.name}
          value={projectAiModule.output}
          editable={true}
          copyable={true}
          copyTooltip={intl.formatMessage({ id: 'copy to clipboard' })}
          onCopied={() =>
            applicationStore.setFlashMessage(
              intl.formatMessage({ id: 'copied to clipboard' })
            )
          }
          shrink={true}
          simple={true}
          onSave={() =>
            onSave(
              projectAiModule.id,
              form.values[`ai_module_output_${projectAiModule.id}`]
            )
          }
        />
      )}
    </ColumnWrapper>
  );
};

export default ProjectAiModuleContent;
